module.exports = __webpack_public_path__ + "img/izidok.baaa69b4.png";